import React from "react";
import "../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
import { FaArrowRight } from "react-icons/fa6";
import indusbgimg from "../bg_images/I_sec1_bg_img.png"
import { AiOutlineArrowRight } from "react-icons/ai";

const Industries = () => {
  return (
    <div className="Industries">
      <div className="I_sec1" style={{ backgroundImage: `url(${indusbgimg})` }}>
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" /> Healthcare
        </h5>
        <h1>Transforming Healthcare with Reliable IT Solutions</h1>
        <p>
          Arshil delivers next-gen healthcare IT solutions that improve
          operations, enhance patient care, and address critical industry
          challenges.
        </p>
        <button className="I_sec1_btn1">
          See Our Services
          <AiOutlineArrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2>What We Offer for Healthcare Providers</h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img className="I_sec2_icon" src="svg/I_sec2_icon3.svg" alt="" />
              Automated Healthcare IT Solutions
            </h6>
            <p>
              Streamline healthcare operations with automated IT systems that
              reduce manual tasks, improve efficiency, and enhance service
              delivery.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img className="I_sec2_icon" src="svg/I_sec2_icon1.svg" alt="" />
              Healthcare IT Security Services
            </h6>
            <p>
              Protect sensitive patient data and ensure compliance with industry
              standaProtect sensitive patient data and ensure compliance with
              industry standards using advanced cybersecurity measures tailored
              for healthcare organizationsrds using advanced cybersecurity
              measures tailored for healthcare organizations
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img className="I_sec2_icon" src="svg/I_sec2_icon2.svg" alt="" />
              Government Healthcare IT Solutions
            </h6>
            <p>
              Build scalable, compliant IT systems that meet the needs of public
              healthcare institutions, ensuring seamless operation and patient
              care
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img className="I_sec2_icon" src="svg/I_sec2_icon4.svg" alt="" />
              Outsourced Healthcare IT Support
            </h6>
            <p>
              Minimize downtime and ensure smooth operations with reliable IT
              support services that keep healthcare systems running without
              interruption
            </p>
          </section>
        </section>
      </div>

      {/* Section 3 */}

      <div className="I_sec3">
        <h2> Solving the Key Challenges in Healthcare IT </h2>

        <section className="I_sec3_cardsContainer">
          <section className="I_sec3_cards">
            <h6>Infrastructure Limitations Hinder Efficiency</h6>
            <p>
              Our automated healthcare IT solutions help upgrade your systems
              with scalable and reliable technology, ensuring smooth operations.
            </p>
          </section>
          <section className="I_sec3_cards">
            <h6>Financial Constraints Slow Innovation</h6>
            <p>
              Arshil provides cost-effective healthcare IT consulting to help
              organizations adopt cutting-edge solutions within budget,
              maximizing impact.
            </p>
          </section>
          <section className="I_sec3_cards">
            <h6>Data Security and Privacy Risks</h6>
            <p>
              Arshil’s healthcare IT security solutions offer enterprise-grade
              protection to secure sensitive information and maintain
              confidentiality.
            </p>
          </section>

        </section>
      </div>

      {/* Section 4 */}

      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>
            How Arshil Transformed Operations For A Healthcare Client And
            Improved Productivity
          </h6>
          <p>
            Our client wanted to create a platform that would connect
            researchers, medical professionals, and patients in India, providing
            a seamless experience for clinical trial participation. Our team
            developed and deployed a robust web application using advanced cloud
            technologies
          </p>
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="images/I_sec4_img1.png"
            alt="image"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>
            Ready to Transform Your Organization with Innovative Healthcare IT?
          </h4>
          <p>
            Partner with Arshil for reliable healthcare IT solutions that
            improve patient care, enhance security, and streamline operations.
            Let’s solve your biggest challenges togethe
          </p>
        </section>
        <section className="I_sec5_right">
          <button>
            Speak to Our Team Today{" "}
            <FaArrowRight className="I_sec5_arrow_right" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Industries;
